import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-forbidden',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './forbidden.component.html',
  styles: [`
    .error-container {
      min-height: 100vh;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;
      background-color: #f8f9fa;
    }

    .logo {
      max-width: 150px;
      margin-bottom: 2em;
    }

    h1 {
      font-size: 6em;
      font-weight: 700;
      color: #dc3545;
      margin-bottom: 0.5em;
    }

    h2 {
      font-size: 2em;
      margin-bottom: 1em;
      color: #343a40;
    }

    p {
      color: #6c757d;
      margin-bottom: 2em;
    }
  `]
})
export class ForbiddenComponent {
  protected readonly portalUrl = `${environment.portalUrl}?referrer=${environment.clientId}`;

  protected goToPortal(): void {
    window.location.href = this.portalUrl;
  }
}
